import Bible from '@/components/Bible/Bible.vue';

export default [
    {
        name: 'bible',
        path: '/bible',
        component: Bible,
        meta: { roles: ['role_administrator'] },
    },
];
